import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.slice(1));
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/login"); return; }

    api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } })
      .then(r => {
        setUser(r.data);
        // Clear the hash immediately so refresh doesn't re-fire this
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${r.data.full_name}`);
        const dest = r.data.role === "admin" || r.data.role === "recruiter" ? "/admin"
          : r.data.role === "employer" ? "/employer" : "/candidate";
        nav(dest, { replace: true });
      })
      .catch(() => { toast.error("Sign-in failed"); nav("/login"); });
  }, [location, nav, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#C5A059] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <div className="text-slate-600">Signing you in…</div>
      </div>
    </div>
  );
}
